import { render } from "./PlatformMacos.vue?vue&type=template&id=a37fd920&scoped=true&ts=true"
import script from "./PlatformMacos.vue?vue&type=script&lang=ts"
export * from "./PlatformMacos.vue?vue&type=script&lang=ts"

import "./PlatformMacos.vue?vue&type=style&index=0&id=a37fd920&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37fd920"]])

export default __exports__